import styles from './connections-list.module.scss';
import { connections } from '../../data';
import { useReducer } from 'react';
import reducer from './connections-list-reducer';
import { RiMessage2Fill } from 'react-icons/ri';
import { IoPersonRemove } from 'react-icons/io5';
import searchButton from '../../images/searchButtonGreen.svg';
import Constants from '../../constants';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import ListItemText from '@material-ui/core/ListItemText';
import Select from '@material-ui/core/Select';
import Pagination from '@material-ui/lab/Pagination';

const initialState = {
  connectionsList: connections,
  sortBy: Constants.RECENTYLY_ADDED,
};
const ConnectionsList = () => {
  const [state, dispatch] = useReducer(reducer, initialState);
  return (
    <main className={styles.container}>
      <article className={styles.header}>
        <section className={styles.search}>
          <h3>All connections</h3>
          <article className={styles.searchBar}>
            <form
              className={styles.searchBar}
              onSubmit={(event) =>
                dispatch({ type: 'SEARCH_VALUE', payload: event })
              }
            >
              <input
                className={styles.searchInput}
                placeholder='Search by name, university or course'
                id='search'
                value={state.searchText}
                onChange={(event) =>
                  dispatch({
                    type: 'SEARCH_TEXT_CHANGE',
                    payload: event,
                  })
                }
              />
              <img src={searchButton} className={styles.searchBtn}></img>
            </form>
          </article>
        </section>
        <section className={styles.sortBy}>
          <span>Sort by: </span>
          <Select
            disableUnderline={true}
            displayEmpty
            value={state.sortBy}
            onChange={() =>
              dispatch({ type: 'SORT_BY_CHANGED', payload: state.sortBy })
            }
            input={<Input />}
            inputProps={{ 'aria-label': 'Without label' }}
          >
            <MenuItem value={Constants.RECENTYLY_ADDED}>
              Recently added
            </MenuItem>
          </Select>
        </section>
        <section className={styles.border}></section>
      </article>
      <article className={styles.list}>
        {state.connectionsList.map((connection) => {
          return (
            <>
              <article key={connection.id} className={styles.connection}>
                <img className={styles.profileImg} src={connection.imgUrl} />
                <div className={styles.profileInfos}>
                  <div className={styles.profielInfo}>
                    <h4>
                      {connection.firstName} {connection.lastName}
                    </h4>
                    <br />
                    {connection.uniShort}
                    <br />
                    {connection.position}
                  </div>
                  <div className={styles.profileInfo}>
                    GRE: {connection.greTotal}
                    <br></br>({connection.greVerbal}V, {connection.greQuants}Q)
                    <br></br>
                    TOEFL: {connection.toeflTotal}
                    <br></br>({connection.toeflWriting}W,{' '}
                    {connection.toeflSpeaking}
                    S, {connection.toeflListening}L, {connection.toeflReading}R)
                  </div>
                  <div className={styles.profileInfo}>
                    Undergrad: {connection.undergrad}
                    <br></br>
                    Undergrad GPA: {connection.undergradGPA}
                    <br></br>
                    Reasearch papers: {connection.researchPapers.length}
                  </div>
                  <div className={styles.actions}>
                    <RiMessage2Fill className={styles.messageIcn} />
                    <button className={`greenButton ${styles.remove}`}>
                      Remove
                    </button>
                    <IoPersonRemove className={styles.removeFriendIcn} />
                  </div>
                </div>
              </article>
              <section className={styles.border2}></section>
            </>
          );
        })}
        <Pagination count={10} className={styles.pagination} />
      </article>
    </main>
  );
};

export default ConnectionsList;
